module.exports = __webpack_public_path__ + "media/delete-button.1245ebd1.svg";